module.exports = __webpack_public_path__ + "img/3.c7974d08.jpeg";